import { createTheme } from '@material-ui/core/styles';

import { palette } from './palette';
import { props } from './props';
import { overrides } from './overrides';

export const osfcDefault = createTheme({
    palette: palette,
    props: props,
	overrides: overrides,
    sidebar: {
        width: 250,
    }
});
